import React from 'react'
import { StylesOf } from '@codeleap/types'
import { useBooleanToggle } from '@codeleap/hooks'
import { createStyles, useCompositionStyles } from '@codeleap/styles'
import { ActionIcon, Drawer } from '@/components'

import { DrawerParts } from '@/config/stylesheets/PageHeader'
import { NavigationMenu } from './NavigationMenu'

export type DrawerMenuProps = {
  styles?: StylesOf<DrawerParts>
}

export const DrawerMenu = (props: DrawerMenuProps) => {
  const { styles, ...rest } = props

  const [drawerOpen, toggleDrawer] = useBooleanToggle(false)

  const compositionStyles = useCompositionStyles(['menuActionIcon', 'drawer', 'navigationMenu'], {...defaultStyles, ...styles})

  return <>
    <Drawer
      debugName='header:drawer'
      open={drawerOpen}
      size={92}
      position='left'
      toggle={toggleDrawer}
      showCloseButton
      {...rest}
      style={compositionStyles.drawer}
    >
      <NavigationMenu withDrawer styles={compositionStyles.navigationMenu} />
    </Drawer>

    <ActionIcon
      debugName='header:menuButton'
      icon='menu-01'
      style={compositionStyles.menuActionIcon}
      onPress={toggleDrawer}
    />
  </>
}

const defaultStyles = createStyles(theme => ({
  drawerBox: {
    ...theme.spacing.padding(3),
    ...theme.spacing.gap(2),
  },
  drawerCloseButtonTouchableWrapper: {
    width: theme.size.largeish,
    height: theme.size.largeish,
    backgroundColor: theme.colors.buttonHighlightPrimaryBgDefault,
    borderRadius: theme.radius.infinite,
    ...theme.border({ color: 'transparent', width: 0 }),
    ...theme.spacing.margin(0),
    ...theme.spacing.marginRight('auto'),
  },
  drawerCloseButtonIcon: {
    width: theme.values.iconSize[2],
    height: theme.values.iconSize[2],
    color: theme.colors.buttonHighlightPrimaryIconDefault,
  },
}))